"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./about.scss");
const core_1 = require("@material-ui/core");
const common_1 = require("../../../../utils/common");
const About = (props) => {
    const noBio = `Please edit your profile and write a brief bio to complete your profile.`;
    const noBioGuest = `Information is not provided.`;
    return (react_1.default.createElement(react_1.Fragment, null, props.edit ? react_1.default.createElement("div", { className: 'common-text' },
        react_1.default.createElement(core_1.TextField, { "data-qa": 'about', value: props.value || '', error: props.error, fullWidth: true, margin: "dense", onChange: (e) => props.inputChange(e), onBlur: (e) => { var _a; return (_a = props.inputBlur) === null || _a === void 0 ? void 0 : _a.call(props, e); }, id: "bio", placeholder: 'Brief Bio', multiline: true, rows: !common_1.ifMobileWidth() ? 5 : 9, variant: "outlined", inputProps: {
                maxLength: 2000
            } })) :
        react_1.default.createElement("div", { className: 'common-text' },
            !props.user.bio && (!props.guest ? noBio : noBioGuest),
            props.user.bio && common_1.reReplaceChars(props.user.bio).split('\n').map((item, i) => react_1.default.createElement("p", { style: { margin: 0 }, key: i }, item)))));
};
exports.default = About;
